import { Link } from 'react-router-dom';
import { Mail, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="footer">
      <div className="container-main">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_cohen-services/artifacts/plc3t0rh_WYCO%20fond%20bleu%20%281%29.jpg"
              alt="WYCO Management"
              className="h-14 w-auto mb-6"
            />
            <p className="text-slate-400 text-sm leading-relaxed max-w-md">
              Consultant indépendant en transformation d'entreprise. 
              Près de 20 ans d'expérience au service de la performance 
              organisationnelle de vos équipes.
            </p>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6">Navigation</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="footer-link text-sm">Accueil</Link>
              </li>
              <li>
                <Link to="/services" className="footer-link text-sm">Services</Link>
              </li>
              <li>
                <Link to="/seminaire" className="footer-link text-sm">Séminaire de Transformation</Link>
              </li>
              <li>
                <Link to="/references" className="footer-link text-sm">Références</Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider mb-6">Contact</h4>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <Mail size={16} className="text-[#BFA15F] mt-1 flex-shrink-0" />
                <a href="mailto:yoann.cohen@wyco.fr" className="footer-link text-sm">
                  yoann.cohen@wyco.fr
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin size={16} className="text-[#BFA15F] mt-1 flex-shrink-0" />
                <span className="text-slate-400 text-sm">
                  France entière · International
                </span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="border-t border-slate-800 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-slate-500 text-sm">
            © {currentYear} WYCO Management. Tous droits réservés.
          </p>
          <p className="text-slate-500 text-sm mt-4 md:mt-0">
            Yoann Cohen · Consultant indépendant
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
